/**
 * AdminDashboard Component
 * Main dashboard page showing statistics and overview
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AdminWrapper from './AdminWrapper';
import { adminService } from '../../_services/admin.service';
import './Admin.css';

class AdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stats: {
                users: { total: 0, activeLastMonth: 0 },
                hairdressers: { total: 0, active: 0 },
                salons: { total: 0, active: 0 },
                bookings: { total: 0, lastWeek: 0 }
            },
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.fetchDashboardStats();
    }

    fetchDashboardStats = async () => {
        try {
            const response = await adminService.getDashboardStats();
            if (response.statusCode === 1) {
                this.setState({
                    stats: response.responseData,
                    loading: false
                });
            } else {
                this.setState({
                    error: 'Failed to load dashboard stats',
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error fetching dashboard stats:', error);
            this.setState({
                error: 'Failed to load dashboard stats',
                loading: false
            });
        }
    }

    formatNumber = (num) => {
        if (num === undefined || num === null) {
            return '0';
        }
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1) + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(1) + 'K';
        }
        return num.toString();
    }

    render() {
        const { stats, loading, error } = this.state;

        return (
            <AdminWrapper>
                <div className="admin-page-header">
                    <h1 className="admin-page-title">Dashboard</h1>
                    <p className="admin-page-subtitle">Overview of your platform</p>
                </div>

                {loading ? (
                    <div className="admin-stats-grid">
                        {[1, 2, 3, 4, 5].map(i => (
                            <div key={i} className="admin-stat-card">
                                <div className="admin-stat-card-header">
                                    <div className="admin-stat-icon" style={{ background: '#e0e0e0' }}></div>
                                </div>
                                <div className="admin-stat-value" style={{ background: '#e0e0e0', width: '60px', height: '36px', borderRadius: '8px' }}></div>
                                <div className="admin-stat-label" style={{ background: '#f0f0f0', width: '80px', height: '14px', borderRadius: '4px', marginTop: '8px' }}></div>
                            </div>
                        ))}
                    </div>
                ) : error ? (
                    <div className="admin-error-banner">
                        <p>{error}</p>
                        <button className="admin-btn admin-btn-secondary" onClick={this.fetchDashboardStats}>
                            Retry
                        </button>
                    </div>
                ) : (
                    <>
                        <div className="admin-stats-grid">
                            <Link to="/beu-admin-x7k9/users" className="admin-stat-card" style={{ textDecoration: 'none' }}>
                                <div className="admin-stat-card-header">
                                    <div className="admin-stat-icon users">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="admin-stat-value">{this.formatNumber(stats.users?.total)}</div>
                                <div className="admin-stat-label">Total Users</div>
                            </Link>

                            <Link to="/beu-admin-x7k9/professionals" className="admin-stat-card" style={{ textDecoration: 'none' }}>
                                <div className="admin-stat-card-header">
                                    <div className="admin-stat-icon professionals">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                            <circle cx="12" cy="7" r="4" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="admin-stat-value">{this.formatNumber(stats.hairdressers?.total)}</div>
                                <div className="admin-stat-label">Professionals</div>
                            </Link>

                            <Link to="/beu-admin-x7k9/businesses" className="admin-stat-card" style={{ textDecoration: 'none' }}>
                                <div className="admin-stat-card-header">
                                    <div className="admin-stat-icon businesses">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                            <polyline points="9 22 9 12 15 12 15 22" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="admin-stat-value">{this.formatNumber(stats.salons?.total)}</div>
                                <div className="admin-stat-label">Businesses</div>
                            </Link>

                            <Link to="/beu-admin-x7k9/bookings" className="admin-stat-card" style={{ textDecoration: 'none' }}>
                                <div className="admin-stat-card-header">
                                    <div className="admin-stat-icon bookings">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                            <line x1="16" y1="2" x2="16" y2="6" />
                                            <line x1="8" y1="2" x2="8" y2="6" />
                                            <line x1="3" y1="10" x2="21" y2="10" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="admin-stat-value">{this.formatNumber(stats.bookings?.total)}</div>
                                <div className="admin-stat-label">Total Bookings</div>
                            </Link>

                            <div className="admin-stat-card">
                                <div className="admin-stat-card-header">
                                    <div className="admin-stat-icon revenue">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                                            <line x1="12" y1="1" x2="12" y2="23" />
                                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="admin-stat-value">£{this.formatNumber(stats.bookings?.totalAmount)}</div>
                                <div className="admin-stat-label">Total Revenue</div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="admin-table-container" style={{ marginTop: '32px' }}>
                            <div className="admin-table-header">
                                <h3 className="admin-table-title">Quick Actions</h3>
                            </div>
                            <div style={{ padding: '24px', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                                <Link to="/beu-admin-x7k9/users" className="admin-btn admin-btn-primary">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                    Manage Users
                                </Link>
                                <Link to="/beu-admin-x7k9/professionals" className="admin-btn admin-btn-secondary">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                        <circle cx="12" cy="7" r="4" />
                                    </svg>
                                    Manage Professionals
                                </Link>
                                <Link to="/beu-admin-x7k9/businesses" className="admin-btn admin-btn-secondary">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                        <polyline points="9 22 9 12 15 12 15 22" />
                                    </svg>
                                    Manage Businesses
                                </Link>
                                <Link to="/beu-admin-x7k9/bookings" className="admin-btn admin-btn-secondary">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                        <line x1="16" y1="2" x2="16" y2="6" />
                                        <line x1="8" y1="2" x2="8" y2="6" />
                                        <line x1="3" y1="10" x2="21" y2="10" />
                                    </svg>
                                    Manage Bookings
                                </Link>
                            </div>
                        </div>
                    </>
                )}
            </AdminWrapper>
        );
    }
}

export default AdminDashboard;
